const _require = require('lodash'),
  cloneDeep = _require.cloneDeep;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;
const _require3 = require('../lib/common'),
  renamePathFragment = _require3.renamePathFragment;
/**
  * @function evalute - evaluate renamePathFragmentBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const object = await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions);
  if (object === undefined) {
    return undefined;
  }
  const oldPath = await evaluateSource(source.oldPath, content, parentContentPath, transientContext, nativeFunctions);
  if (oldPath === undefined) {
    return undefined;
  }
  const newPath = await evaluateSource(source.newPath, content, parentContentPath, transientContext, nativeFunctions);
  if (newPath === undefined) {
    return undefined;
  }
  const objectCopy = cloneDeep(object);
  renamePathFragment(objectCopy, oldPath, newPath);
  return objectCopy;
};
module.exports = {
  evaluate
};